module.exports = __webpack_public_path__ + "static/media/builtinv2-osveshenie-1.fe41d929.png";